import moment from 'moment';

export default function ($scope, $stateParams, getImportDetails, getImportRecords, $filter) {
    const importId = $stateParams.importId;

    /* --- */

    $scope.recordsNotFetched = true;
    $scope.errorsOccurred = false;
    $scope.columnNames = [];

    /* --- */

    getImportDetails(importId)
    .then(importDetails => {
        $scope.importDetails = importDetails;
        $scope.errorsOccurred = false;
    })
    .catch(() => {
        $scope.errorsOccurred = true;
    });

    getImportRecords(importId)
    .then(records => {
        $scope.recordsNotFetched = false;
        $scope.records = records;
        $scope.columnNames = getColumnNames(records);
    })
    .catch(() => {
        $scope.errorsOccurred = true;
    });

    /* --- */

    function getColumnNames(records) {
        if (!Array.isArray(records) || records.length < 1) {
            return [];
        }

        return Object.keys(records[0]).filter(x => x !== '$$hashKey');
    }
}



// WEBPACK FOOTER //
// ./Client/app/data-import-export/controllers/import/detail/importDetailCtrl.js